import { colors } from '../theme/colors';
import images from './images';
import strings from './strings';

export const ourTeamArray = [
  {
    name: 'Andrei Stoica',
    role: 'CEO',
    companyRelationship: 'internal',
    profilePic: images.Stoica,
    profilePicHover: images.StoicaArt,
    responsibility: 'Everything',
    experience: '5+ years',
    email: 'andrei.stoica@nomorecoffeeplease.com',
    phone: '+40 742 826 647',
    facebook: 'https://www.facebook.com/profile.php?id=100010321871999',
    instagram: '',
    linkedin: '',
    personalExp:
      'Hello! Nice to meet you! My name is Andrei and I’ve been working with React-Native for 4 years now. With extensive experience working in an Agile environment, I have led multiple small and large teams and worked on various projects with legacy and new codebases. I am also a leader and mentor, with experience in tech-leading positions, product ownership, and project management. I am client-facing, promoting good coding practices, and helping integrate new team members into projects.',
    personalSkills: [
      { skill: 'React-Native', percentage: '5+ years' },
      { skill: 'React', percentage: '5+ years' },
      { skill: 'Redux, Toolkit, Saga, Thunk', percentage: '3 years' },
      { skill: 'Webpack', percentage: '1 year' },
      { skill: 'Babel', percentage: '1 year' },
      { skill: 'WebRTC & Janus', percentage: '2 years' },
      { skill: 'Typescript', percentage: '5+ years' },
      { skill: 'Vanilla JS', percentage: '4 years' },
      { skill: 'CSS', percentage: '2 years' },
      { skill: 'Google Maps SDK', percentage: '3 years' },
      { skill: 'Firebase', percentage: '4 years' },
      { skill: 'Matrix open source protocol', percentage: '2 years' },
      { skill: 'Clean Code', percentage: '' },
      { skill: 'Version control: Git', percentage: '' },
      { skill: 'Task management tools: Jira, Trello', percentage: '' },
      { skill: 'Class & Functional programming', percentage: '' },
      { skill: 'Agora', percentage: '' },
      { skill: 'GraphQL', percentage: '' },
      { skill: 'Unit Tests', percentage: '' },
      { skill: 'CI/CD, automatic deploys', percentage: '' },
      { skill: 'Gitlab pipelines', percentage: '' },
      { skill: 'Google Analytics implementation', percentage: '' },
      { skill: 'Material UI Kit', percentage: '' },
      {
        skill: 'Smooth animations in React-Native (Reanimated)',
        percentage: '',
      },
      { skill: 'Jira task management / project management', percentage: '' },
      { skill: 'Scrum ceremonies and methodology', percentage: '' },
    ],
    projects: [
      {
        name: 'Pentalog, a Globant division',
        projectType: 'React Developer',
        time: 'Jan 2022 - Present',
        description: `Equipped with a nice team and good leadership, Citadel is my main project where I’ve learned how a scaled project struggles to keep up with the new features requests as well as technical debt and pushing code upgrades here and there.`,
        responsibilities: `Holding interviews for React and React-Native\nMaking code Audits\nCitadel`,
        acquiredSkills: `WebRTC, Video / Audio conferences, Improved understanding of ReactJS and data management, Flux, Electron, Karma, Mocha, SlateJS`,
        technology: `React, WebRTC with Janus, Matrix-SDK, RestAPI’s, Redux Toolkit, Hooks & Lifecycle methods are both used, SlateJS.`,
        projectScreens: [],
      },
      {
        name: 'IBM Romania',
        projectType: 'React-Native Developer & Technical Lead',
        time: 'Jul 2020 - Dec 2021',
        description: `At IBM I’ve worked on 2 main projects with React-Native:
    1. SNCM (Belgium’s public transportation company). Together with the team from the client I’ve helped develop different functionalities as well as fixing bugs on the mobile app.
    2. My-Hyundai - The mobile app for Hyundai that takes your Hyundai cars and manages them.`,
        responsibilities: `While working at SNCB I was responsible for maintaining / hypercaring the app through the delivery process.\nFixing bugs that came from end-client feedback.\nI was in charge of certain features and bug fixing inside the app, mainly worked with timetables, calendars and the REST Api that we had for data manipulation.\nI’ve particularly implemented the Accessibility in the app and the Dark Mode theming.`,
        acquiredSkills: '',
        technology: `React-Native, Redux, Native Modules (We’ve had one for a custom Android Calendar ), GraphQL, REST api.`,
        projectScreens: [],
      },
      {
        name: 'Nomorecoffeeplease',
        projectType:
          'Senior React & React-Native Developer, Technical Lead, Mentor, Founder, Administrator, Business Analyst',
        time: 'Jul 2020 - present',
        description: `Nomorecoffeeplease was an experiment of mine. Basically, I wanted to start a company and see where it fails and make progress based on failures. Because of my emphasis on vision and values, and because of my close friends that I’ve worked with, I think this experiment succeeded.`,
        responsibilities: `Client negotiation, communication, planning and processes implementation and enforcement.\nReact & React-Native skills by teaching others and mentoring.\nCareer planning and opportunity seeking (for me and for others)\nLeadership concepts and applying them in real scenarios - Company management, raising managers, company financial planning, creating new departments, managing people - Raising internal startups such as: BookTrade and others.\nWhile working for several companies through NMCP, I’ve learned: - Setting up automatic deploys to ngnix server with github actions - Security and Performance key points when developing a mobile app / web platform - WebRTC with matrix-sdk (a messenger + video calls platform ) - Rebasing workflow git - Working with tags and yml files for automatic deploys - Adding Tests to the code, learning what TDD means (not actually working like that ) - Working with multiple repos / mono repos - Learning Electron platform - Getting familiar with Angular and Ionic framework ( had a little bit of work on those ) - Making responsive UI in React using breakpoints in CSS - Working with web sockets - Working with hooks, react-query and async storage instead of redux - PreactJS Notable integrations: All Firebase functionalities, Redux ( Thunk & Saga ), Automatic Deploys on Nginx servers using Github Actions, Google Maps SDK, Push notifications, Deeplinks, WebRTC, Web sockets, HTTP Requests. Typescript, Electron.`,
        acquiredSkills: '',
        technology: '',
        projectScreens: [],
      },
      {
        name: 'Redbeesoftware',
        projectType: 'Frontend Developer',
        time: 'Jan 2019 - Dec 2021',
        description: `While working for Redbeesoftware I’ve been included in quite a few projects, some of them are:\n- SportsBet ( in collaboration with Xoomworks )\n- Prepino ( in collaboration with Salt&Pepper )\n- FoodStyles ( in collab with Coremaker )\n- A processes management mobile app\n- Habari ( in collab with Work in Progress )\n- Covid19 mobile app (for Romanian Government)`,
        responsibilities: '',
        acquiredSkills: `- working with huge apps and teams that require different approval processes when submitting changes to the code base.\n- Interesting code splitting when working with big apps such as: splitting the business logic from the UI (Sports Bet).\n- Working Agile with Small - Medium teams’ sizes. Fast delivery and working after hours to finish ASAP for a good cause (Covid-19 app).\n- Learned to always use typescript even for small scale apps. If possible`,
        technology: `Redux (Thunk & Saga), Typescript, Apollo with GraphQL, Performance optimization of lists & working with big lists, Publishing NPM packages.`,
        projectScreens: [],
      },
    ],
  },
  {
    name: 'Andreea',
    role: 'HR',
    companyRelationship: 'internal',
    profilePic: images.Andreea,
    profilePicHover: images.AndreeaArt,
    responsibility: 'Tech',
    experience: '4 years',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    personalExp: '',
    personalSkills: [],
    projects: [],
  },
  {
    name: 'Norbi',
    role: 'CTO',
    companyRelationship: 'collaborator',
    profilePic: images.Norbi,
    profilePicHover: images.NorbiArt,
    responsibility: 'Tech',
    experience: '4 years',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    personalExp: '',
    personalSkills: [
      { skill: 'JavaScript', percentage: '' },
      { skill: 'TypeScript', percentage: '' },
      { skill: 'React', percentage: '' },
      { skill: 'React Native', percentage: '' },
      { skill: 'Bootstrap', percentage: '' },
      { skill: 'MUI', percentage: '' },
      { skill: 'NodeJS', percentage: '' },
      { skill: 'Firebase', percentage: '' },
      { skill: 'Redux', percentage: '' },
      { skill: 'Context API', percentage: '' },
      { skill: 'Project architecture', percentage: '' },
      { skill: 'GIT', percentage: '' },
      { skill: 'PHP', percentage: '' },
    ],
    projects: [
      {
        name: 'Randstad Digital - NXP Package Manager',
        projectType: '',
        time: 'June 2022 - Present',
        description:
          'Package Manager is a web application that delivers application-specific production-ready source code in a single bundle. When users select packages from the interface there are multiple checks that run in the frontend to verify their compatibility.',
        responsibilities:
          "First few weeks I mostly worked on bug fixing and improving the performance of the app. Most of the features at the time were already implemented, but the architecture of the app wasn’t scalable, making it proprietary to improve the app's performance. After a while the team decided to rewrite the code and I helped on implementing the new architecture, rewriting one of the biggest features of the app.\nThe production and development environments had a lot of differences and we also didn’t have control of the deployment in production. Because of that a few times we had to do “firefighting”, discovering that I can handle working under pressure.",
        acquiredSkills:
          'Better understanding of React (and any application) architecture\nIn depth knowledge about Context API and custom hooks\nWorking under pressure',
        technology: 'React, MUI, Context API',
        projectScreens: [],
      },
      {
        name: 'MBSR',
        projectType: '',
        time: 'March 2021 - June 2022',
        description:
          'This app mostly pulls data from different sources and aggregates the data into charts. One of the main sources were surveys. We did this using Alchemer’s api. Other 2 important data sources were interviews ( that were held using this tool ) and BSR Team input ( also using this tool ). This project helps the BSR team to highlight the issues/topics that different companies have problems with.',
        responsibilities:
          'MBSR is one of the biggest projects ongoing in NoMoreCoffeePlease and my first big project structured and implemented from scratch. I also led a team of 3 for this project.\nFor this project we used React with SCSS for styling, NodeJS for the backend and MySQL for the database.',
        acquiredSkills:
          'Learnt about leadership and managing a small team\nCommunications skills when discussing about the product with the client',
        technology: 'React, SCSS, NodeJS, MySQL',
        projectScreens: [],
      },
      {
        name: 'NMCP Website',
        projectType: '',
        time: 'January 2021 - March 2021',
        description: 'NoMoreCoffeePlease’s website’s second iteration',
        responsibilities:
          'I helped with the UI for NoMoreCoffeePlease’s website using React and SCSS. I also implemented and designed the blog section, using Processwire.',
        technology: 'React, SCSS, ProcessWire',
        projectScreens: [],
      },
      {
        name: 'ChalkNotes',
        projectType: '',
        time: 'April 2020 - January 2021',
        description:
          'ChalkNotes is an app that offers its users the ability to create communities and to offer customized experiences based on the community that you selected.',
        responsibilities:
          'The main features are based on react-native-maps and firebase. This is the first project I used Redux Thunk and not Saga but in a few days I understood how it works and I was ready to implement the new features. I worked a lot on bug fixing and improving the performance of the app and then on the main functionality of the app. Based on the data from firebase I had to create pins on the map and connect them. The pins that the user accessed also had a starting point and a direction so I had to check if the user goes to each pin in order.',
        acquiredSkills:
          'Improving React/React Native performance\nLearnt how to work with react-native-maps\nWorking with location and other parameters provided by phones.\nDeploying android and iOS applications',
        technology: 'React Native, Firebase, react-native-maps, Stripe',
        projectScreens: [],
      },
      {
        name: 'Moonlet',
        projectType: '',
        time: 'January 2020 - April 2020',
        description: 'This application is a crypto wallet.',
        responsibilities:
          'Most of the blockchain part was already implemented when I got on the project. But I was the one who connected the app to the physical wallets. There were 2 types of connections: bluetooth and usb, both for web and mobile.',
        acquiredSkills:
          'Even if I didn’t have tasks regarding the actual blockchain I learnt a lot of things about it and how it works.\nThis project heavily relied on OOP and I felt really excited after using functional programming for so long, refreshing my knowledge from university',
        technology: 'React Native, OOP, Redux, Blockchain',
        projectScreens: [],
      },
      {
        name: 'IziBac',
        projectType: '',
        time: 'August 2019 - January 2020',
        description:
          'IziBac is an app that helps students learn for the baccalaureate exam.',
        responsibilities:
          'My main job on this project was to implement the onboarding feature. I needed to create overlays over screens and highlight specific elements and show explanations for them.\nWhile collaborating with the IziBac team I learned a lot of things about sprints, sprint reviews, and other forms of planifications and team management.',
        technology: 'React Native, React-Navigation, Redux + Saga, Storybook',
        projectScreens: [],
      },
      {
        name: 'NoMoreCoffeePlease - Booktrade',
        projectType: '',
        time: 'January 2019 - August 2019',
        description:
          'NoMoreCoffeePlease’s first internal app. The project revolves around Matching with people that have a common interest in one another’s books. Then the trade would happen.',
        responsibilities:
          'My role was to structure the database and implement the matching algorithm.',
        acquiredSkills:
          'Learnt a lot about mobile apps bundle ids and where they are required\nIn depth knowledge about Redux and firebase',
        technology:
          'React Native, React-Navigation, Redux + Saga, Firebase’s Firestore',
        projectScreens: [],
      },
    ],
  },
  {
    name: 'Nico',
    role: 'CFO',
    companyRelationship: 'internal',
    profilePic: images.NicoStoica,
    profilePicHover: images.NicoStoicaArt,
    responsibility: 'Tech',
    experience: '4 years',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    personalExp: '',
    personalSkills: [],
    projects: [],
  },
  {
    name: 'Andrei',
    role: 'Mid React-Native Dev',
    companyRelationship: 'collaborator',
    profilePic: images.AndreiPop,
    profilePicHover: images.AndreiPopArt,
    responsibility: '',
    experience: '3 years',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    personalExp:
      'Greetings! I’m Andrei, and I’ve been a React-Native and React developer for over 3 years now. I’m passionate about software development and solving complex problems, fishing, and football. My goal is to be a great developer and work on interesting projects, developing myself every day. I started to learn a bit of programming by myself when I was 13, but really got into it in high school. There I studied and learned a bit of C++, but more than that, I developed my logical thinking. Afterwards, I went to university to get my “Computer Science” degree. Meanwhile, I found about the React JS framework, and it was a match made in heaven for me. It’s been almost 4 years now, and I enjoyed every moment of being in the wonderful world of React.',
    personalSkills: [
      {
        skill: 'Javascript',
        percentage: '3.5 years',
      },
      {
        skill: 'React-Native',
        percentage: '3.5 years',
      },
      {
        skill: 'Git',
        percentage: '3.5 years',
      },
      {
        skill: 'Jira',
        percentage: '3.5 years',
      },
      {
        skill: 'React',
        percentage: '3 years',
      },

      {
        skill: 'Firebase',
        percentage: '3 years',
      },

      {
        skill: 'Typescript',
        percentage: '3 years',
      },
      {
        skill: 'Redux',
        percentage: '3 years',
      },
      {
        skill: 'MySQL',
        percentage: '0.5 years',
      },
      {
        skill: 'NodeJS',
        percentage: '0.5 years',
      },

      {
        skill: 'Kotlin(Android Studio)',
        percentage: '0.5 years',
      },
      {
        skill: 'Swift(XCode)',
        percentage: '0.5 years',
      },
      {
        skill: 'Zeplin',
        percentage: '0.3 years',
      },
      {
        skill: 'Trello',
        percentage: '0.3 years',
      },
      {
        skill: 'AWS',
        percentage: '0.3 years',
      },
    ],
    projects: [
      {
        name: 'Prestige Cakes',
        projectType: 'Web Dev',
        description: 'An e-commerce website for a local pastry shop',
        time: 'Decembrie 2023 - January 2023',
        projectScreens: [],
        responsibilities: 'Scrum Master, Project Manager, Tech Leader',
        acquiredSkills: `Working with Jira, creating detailed tasks, on-point estimations, in-depth code
          review, project architecture, client communication, understanding client needs`,
        technology: 'React, Firebase, SCSS, Jira.',
      },
      {
        name: 'Haapi',
        projectType: 'Web Dev',
        description: `A JavaScript module that integrates HostAwayApi's for a simple
        implementation of its functionalities into any website that has apartments for rental.`,
        time: 'September 2023- November 2023',
        projectScreens: [],
        responsibilities: 'Scrum Master, Project Manager, Tech Leader',
        acquiredSkills: `Communication with the team, Logical thinking in whole flow of an app,
        dealing with unexpected issues.`,
        technology: 'JavaScript, Firebase, HostAwayApi.',
      },
      {
        name: 'Pentalog',
        projectType: 'Web Dev',
        description: `Vivlio is a company that develops mobile applications with the purpose
        of reading different e-books.`,
        time: 'November 2022 - August 2023',
        projectScreens: [],
        responsibilities: `My main responsibility was to be a front-end developer for their enterprise
        team. This means I had to create apps that were going to be sold to their clients by using their
        already developed libraries. My job there implied:
        - Customizing apps to suit the client needs
        - Adding new features to already existing apps as requested
        - Fix bugs that could appear after
        creating a new app in their suite
        - Modifying the native part of their libraries to achieve the desired requirements
        - Researching for new possibilities to make the work of creating a new app easier
        - Create NPM React-Native modules`,
        acquiredSkills: `- Learnt a lot about mobile apps bundle ids and where they are required
        - Gained a small experience creating npm react-native modules and working in the native part
        (Swift & Kotlin)
        - Started to learn Jest for Unit Testing
        
        - Worked in a monorepository for multiple projects and linking between them`,
        technology: 'React-Native, Jest, Swift (XCode), Kotlin(Android Studio)',
      },
      {
        name: 'BSR',
        projectType: 'Web Dev',
        description: `Based on the client's Excel processes, we developed Materiality, a web
          platform that integrates multiple data points into a time-based chart.`,
        time: 'September 2021 - January 2022 & May 2022 - October 2022',
        projectScreens: [],
        responsibilities: `My main goal was to fix bugs and implement new functionalities. I’ve
        optimized the app as there were a lot of fetches. I’ve implemented new functionalities. I’ve
        fixed UI/logical bugs, and I’ve altered the database. My biggest challenge was to learn how to
        work with backend/database and AWS on my own.`,
        acquiredSkills: 'MySQL, Amazon AWS, NodeJS, Improved logical thinking.',
        technology: 'React, Amazon AWS, MySQL, NodeJS.',
      },
      {
        name: 'Yael Consulting',
        projectType: 'Mobile Dev',
        description: 'IBEX',
        time: 'June 2021 - August 2021',
        projectScreens: [],
        responsibilities:
          'My main responsibility was to Implement MUI components and to manage the frontend data. I’ve worked with MUI components and managed redux data. I’ve also manipulated the data from backend.',
        acquiredSkills:
          'MUI, redux with thunk, manipulating big data from backend',
        technology: 'React, Redux, Thunk, MUI.',
      },
      {
        name: 'Oasis Residence',
        projectType: 'Web Dev',
        description: 'Aparthotel Platform.',
        time: 'March 2021 - May 2021',
        projectScreens: [],
        responsibilities:
          ': My main responsibility was to create the reservation algorithm (showing the free dates, blocking dates in database after reserving, check-in & check-out dates). I’ve integrated the payment flow with stripe for reservations (pay, get e-mail with the invoice). I’ve created the functionality for sending e-mails from the app. Also, I’ve implemented the UI from Adobe XD and I’ve fixed the UI bugs for every screen size. My biggest challenge was developing the stripe payment integration.',
        acquiredSkills:
          'advanced CSS techniques, HTML Forms, Nodemailer usage, Firebase functions deployment and usage, payment implementation with stripe',
        technology: 'React, Firebase, Stripe',
      },
      {
        name: 'BookTrade',
        projectType: 'Mobile Dev',
        description: `A book trading app, whose goal is to facilitate the way people can acquire
        books. Instead of keeping the books in the library for ages, users have a real solution for trading
        
        them. This creates connections and communities.`,
        time: 'August 2020 - February 2021 & February 2022 - April 2022',
        projectScreens: [],
        responsibilities:
          'My main responsibility was to develop new features and to make bug fixing on IOS especially. I created the logic for the main functionality which was the matching system. I’ve used firebase to manage all the data from the app, and I’ve integrated authentication flow. Also, I’ve implemented notifications from app. My biggest Challenges were making notifications work on IOS and getting the matching system to work at every swipe.',
        acquiredSkills:
          'Firebase, PushNotifications, Data handling, Authentication Flow',
        technology:
          'React-Navigation, Redux & Saga, Facebook/Google Authentication, Firebase.',
      },
      {
        name: 'inMatrix',
        projectType: 'Mobile Dev',
        description: `An event organizing app, connecting vendors and customers.Vendors
        manage plan events and customers make secure bookings and payments—all in one intuitive
        mobile app.`,
        time: 'May 2020 - July 2020',
        projectScreens: [],
        responsibilities: `My main responsibility was to Implement UI from Zeplin and API fetches
          from backend. Other than that I also made the business logic for canceling reservations and
          implemented some other new features that were required.`,
        acquiredSkills: `Making responsive mobile UI, HTTP requests with axios, dealing with
        side-effects, typescript`,
        technology: 'React-Native, Redux Saga, TypeScript, Zeplin, Trello',
      },
      {
        name: 'Emoji Picker Challenge',
        projectType: 'Mobile Dev',
        description:
          'A small app that shows a chat and a slack-like emoji picker.',
        time: 'April 2020',
        projectScreens: [],
        responsibilities:
          'My main goal was to create an emoji picker similar to the one on Slack. I’ve developed the text input work. My biggest challenge was navigating through emoji’s categories.',
        acquiredSkills: 'React hooks, working with components.',
        technology: 'React-Native',
      },
      {
        name: 'Movie App Challenge',
        projectType: 'Mobile Dev',
        description:
          'An app that contains informations about Star Wars movies.',
        time: 'March 2020 - April 2020',
        projectScreens: [],
        responsibilities:
          'My main goal was to gather data from the Star Wars API and to create a design for it. I’ve worked with an array of object, and I’ve navigated from a category to the details of it. My biggest challenge was solving side-effects from multiple http fetches.',
        acquiredSkills: 'Axios, React-Native navigation, Project architecture',
        technology: 'React-Native',
      },
    ],
  },
  {
    name: 'Denis',
    role: 'Senior React-Native Dev',
    companyRelationship: 'collaborator',
    profilePic: images.Denis,
    profilePicHover: images.DenisArt,
    responsibility: 'Tech',
    experience: '3 years',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    personalExp:
      'Hello! Nice to meet you, I’m Denis, a React-Native developer for almost 3 years now. I’m passionate about everything that has to do with technology, that’s why I want to learn as much as possible in a short amount of time. Mobile development has been the starting point for me, and I still have lots to learn each day. My goal is to become a master at my craft, and be really valuable for any team that needs a tech guy that if he doesn’t know how to do it, he learns how to do it in a fast manner. Creativity from a UI perspective is not my strongest point, as I like technical challenges more, that require research and are hard to do, so I can learn.',
    personalSkills: [
      {
        skill: 'Perfect UI: worked with Figma / AdobeXD',
        percentage: '',
      },
      {
        skill: 'Architecture of the project',
        percentage: '',
      },
      {
        skill:
          'Mobile Performance Optimisation - Hooks and Functional Programming',
        percentage: '',
      },
      {
        skill: 'Classes and Lifecycle methods',
        percentage: '',
      },
      {
        skill:
          'Firebase and it’s functionalities: FireStore, Cloud Functions, Analytics',
        percentage: '',
      },
      {
        skill: 'Maps work: Apple / Google',
        percentage: '',
      },
      {
        skill: 'SDK’s: Facebook, Twitter, Instagram, LinkedIn',
        percentage: '',
      },
      {
        skill: 'Global State managers: Redux with Saga / Thunk',
        percentage: '',
      },
      {
        skill: 'React Navigation',
        percentage: '',
      },
      {
        skill: 'Xcode / Android Studio',
        percentage: '',
      },
      {
        skill: 'Releases to Appstore / Google Play Store of applications',
        percentage: '',
      },
      {
        skill: 'Automations with CircleCI / Pipelines',
        percentage: '',
      },
      {
        skill: 'HOC’s and where to use them, ex: theming and state keep, auth',
        percentage: '',
      },
      {
        skill: 'Algorithms: Binary Tree Search, Dijkstra, etc.',
        percentage: '',
      },
      {
        skill: 'HTTP Requests, Error / Successful codes, Sockets',
        percentage: '',
      },
      {
        skill:
          'NodeJS: Auth Flows, JWT token: expiration, Encrypted passwords, endpoints',
        percentage: '',
      },
      {
        skill: 'Native Modules: AR kit on IOS, Bridging',
        percentage: '',
      },
      {
        skill: 'Payments with Stripe(card & ApplePay)',
        percentage: '',
      },
      {
        skill:
          'Threads ( not work with them but got a good understanding of them )',
        percentage: '',
      },
      {
        skill: 'Jira tasks and workflow',
        percentage: '',
      },
      {
        skill: 'Modular, clean code and easy to read',
        percentage: '',
      },
      {
        skill: 'Git',
        percentage: '',
      },
      {
        skill: 'Typescript',
        percentage: '',
      },
      {
        skill: 'API integration',
        percentage: '',
      },
      {
        skill: 'Re-usable components, good project management',
        percentage: '',
      },
      {
        skill:
          'Working with cloud( firebase cloud function, cloud python server)',
        percentage: '',
      },
      {
        skill:
          'Modifying node modules I also have experience with other languages like: Java, Python, C++, C, C#, Assembly, SQL and a little of Swift',
        percentage: '',
      },
    ],
    projects: [
      {
        name: 'Passport Authenticator',
        time: '2023 December - 2024 February (ongoing)',
        description:
          'Passport authenticator is a mobile project that will serve as an authenticator for other services like Ghiseul.ro, SPV and others that will allow users to authenticate to those services through the app by creating an account and linking information from passport, identity card or others. In order to approve that those information are valid, the user should take a picture of the document and scan the NFC tag on it(if there’s any) and after that the app will ask the user to take a photo of itself to match the photo with the one from the document.',
        responsibilities:
          "In this project, I had to create it from scratch, which involved crafting the project's architecture, determining the necessary libraries, ensuring the screens are pixel perfect to fit all phone displays, discussing the back-end to define required endpoints, and exploring functionalities that can be implemented on the user side based on the provided design.",
        acquiredSkills: '',
        technology: 'React-Native',
        projectType: '',
        projectScreens: [],
      },
      {
        name: 'Ness Technology',
        time: '2023 August - 2023 October',
        description:
          'This project is a platform for schools that are based in the UK and it was previously written in jQuery and it should be re-implemented to React. This was based on different types of tests that a teacher can make from selecting questions types and to send them to their students. By selecting a question type, the teacher could see two sections, one that can only the test maker can see and can set the correct answers(s)/partial answer(s) and customize the working area of the test taker(student), like the height, width for each of the fields and limitations on those, like if it can or cannot use spaces, numbers, letters, etc. The second section is the test taker section and there it can be seen from a test taker perspective. I joined this project for a short amount of time to help the implementation in React go faster, therefore in this time I’ve implemented a question type based on math entries.',
        responsibilities: '',
        acquiredSkills: '',
        technology: 'ReactJS, jQuery, Learnosity',
        projectType: '',
        projectScreens: [],
      },
      {
        name: 'Customer Companion',
        time: '2022 September - 2023 December',
        description:
          'Customer Companion is a proprietary platform for a company that enables users to access, modify, and occasionally create various forms of data. This project consolidates data from multiple company projects and systems, facilitating a streamlined visualization process without the need to navigate through individual projects.',
        responsibilities:
          'My involvement in this project primarily focused on refactoring pages from the previous application, which was built using jQuery, to React. This entailed creating reusable components with customizable options for different use cases, optimizing code for improved performance, and collaborating with the back-end team to modify or update endpoints. Throughout the process, I had to carefully implement impactful changes, such as introducing row expansion and in-cell editing for the grid, while reducing the risk of introducing new bugs.\nAdditionally, I provided support to colleagues utilizing the components and functions I developed.\n- Refactoring the legacy front-end codebase\n- Optimizing components and requests\n- Engaging in discussions with third-party library support services (Kendo library)\n- Providing UX suggestions to our designer for a more seamless user experience\n- Code review',
        acquiredSkills:
          "Key features that I worked on included the file manager, charts, spreadsheet, map, menu and action drawers, dynamic filters, and data loading on scroll. Furthermore, I successfully suggested and implemented various refactoring efforts with our team, which includes improving the project's architecture, removing and compressing code to enhance code reusability, and other related optimizations.",
        technology: 'ReactJS, RemixRun, C#, jQuery, KendoReact',
        projectType: '',
        projectScreens: [],
      },
      {
        name: 'BSR',
        time: '2022 April - 2022 September',
        description:
          "BSR it's a B2B organization which helps identify potential risks or issues in any business, no matter its sector. BSR will interview all team members, gather data and based on these, will come up with a list of things to improve in your business.",
        responsibilities:
          'Discussing Jira tasks and make estimations, Technical Lead - Bug fixing, Create the AM Chart for showing data from the backend, DB connection fixing with AWS hosting service\nMaintenance, Develop a few new features',
        acquiredSkills: '',
        technology: 'ReactJS, NodeJS, SQL DB, AWS, AM Charts',
        projectType: '',
        projectScreens: [],
      },
      {
        name: 'ERM',
        time: '2022 February - 2022 April',
        description: 'E-commerce web platform.',
        responsibilities:
          'Technical Lead, Architect the whole backend, Create authentication flows with JWT token, Create basic endpoints for the project, Code review for the FrontEnd members',
        acquiredSkills: '',
        technology: 'ReactJS, NodeJS, MongoDB',
        projectType: '',
        projectScreens: [],
      },
      {
        name: 'ChalkNotes',
        time: '2020 March - 2022 February',
        description:
          'Create with React-Native a mobile app that has interactive Google Maps on which there are Clustered Markers. These markers represent a trail which a user can follow to complete an experience. The experience can be divided into multiple ones and read a different ending.',
        responsibilities:
          'At first, I had to integrate into the team, where I had a technical lead and a team manager that I worked with. I worked directly with the client on this project. So, I learned a lot on how to discuss and negotiate tasks and how tasks should look, before taking them into development (definition of done). My responsibilities relied on fixing bugs, improving performance of the app by eliminating memory leaks and badly used hooks. The project was taken from another team of developers and had most of the system: Redux, Firebase, and lots of bugs. The performance wasn’t too great and I reimplemented a lot of features like: Maps, Notes system, Proximity detection, unlocking a Note based on certain logic and so on. The idea was that I had to implement fully functional features from the start, not only small things.',
        acquiredSkills:
          'Google Maps SDK, Markers, Poly lines on map, Custom Algorithms, VR external module: Viro and tried to integrate LightShip SDK into React-Native with no success at the end because of time but could be done in the future.',
        technology:
          'Viro VR, React-Native, LightShip SDK, Unity, Google Maps SDK, Firebase, Cloud functions, Cron Jobs, Web Sockets',
        projectType: '',
        projectScreens: [],
      },
    ],
  },
  {
    name: 'Daniel',
    role: 'Mid React-Native Dev',
    companyRelationship: 'collaborator',
    profilePic: images.DanielLaios,
    profilePicHover: images.DanielLaiosArt,
    responsibility: '',
    experience: '3 years',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    personalExp:
      'Hi! I am Daniel, a Mid React-Native developer who can create mobile apps and is eager to learn new things. In the last 3 years I had the opportunity to develop a few mobile apps, getting the chance to put in practice what knowledge and experience I have accumulated from my internship and from college. Because software development has always been a passion, I am also familiar with backend development, mostly Express, databases and even hardware description languages such as VHDL.',
    personalSkills: [
      { skill: 'React Native Development', percentage: '' },
      { skill: 'AWS Proficiency', percentage: '' },
      { skill: 'Database Management', percentage: '' },
      { skill: 'State Management', percentage: '' },
      { skill: 'API Integration', percentage: '' },
      { skill: 'Firebase Integration', percentage: '' },
      { skill: 'Version Control and Collaboration', percentage: '' },
      { skill: 'Mobile App Development Tools', percentage: '' },
      { skill: 'Problem Solving and Debugging', percentage: '' },
      { skill: 'Programming Languages', percentage: '' },
      { skill: 'Frontend Development', percentage: '' },
      { skill: 'Map Integration', percentage: '' },
      { skill: 'Image Compression', percentage: '' },
      { skill: 'CI/CD', percentage: '' },
    ],
    projects: [
      {
        name: 'BSR',
        projectType: 'Web Dev',
        description: `Materiality, a web platform for enhancing Excel processes, integrating
        diverse data points into a time-based chart. This centerpiece chart enables users to analyze
        historical changes, identify key business topics, and rate their importance. Overcoming
        challenges, the app facilitates seamless interaction with data, allowing users to modify,
        import/export Excel files, retrieve external tool information, and perform diverse functions. The
        project focused on creating a user-friendly interface for complex data interaction, visualizing
        trends, and enabling on-the-go changes with automatic data saving.`,
        time: 'November 2023 - Present',
        projectScreens: [],
        responsibilities: `Delivering efficient clean code, implementing development environments in
        AWS, automating DB archiving, implementing a LLAMA2 API using AWS Bedrock, taking
        part in the review process, creating architectural diagrams in order to document the processes
        used.`,
        acquiredSkills:
          'Better understanding of AWS, understanding of Boto3 library',
        technology: `AWS (Amplify, Bedrock, Cognito, Lambda, RDS), React, Node JS,
        MySQL`,
      },
      {
        name: 'Odeen Software',
        projectType: 'Mobile Dev',
        description: `Offline first management app that aims to improve and automate the
        process of dispatching a maintenance worker to remote job sites.`,
        time: 'January 2023 – November 2023',
        projectScreens: [],
        responsibilities: `Delivering efficient clean code, taking part in the review process,
        participating in meetings with the clients.`,
        acquiredSkills: `Building an offline first application, Redux Offline, in depth understanding
        of Keycloak (creating a patch for the library)`,
        technology: 'Redux Offline, Keycloak, React Native, Typescript',
      },
      {
        name: 'ChalkNotes',
        projectType: 'Mobile Dev',
        description:
          'Create with React-Native a mobile app that has an interactive Google Maps on which there are Clustered Markers. These markers represent a trail which a user can follow to complete an experience. The experience can be divided into multiple ones and read a different ending.',
        time: 'May 2021 - January 2023',
        projectScreens: [],
        responsibilities:
          'The most challenging task I had to do on this app was to implement sharing functionality for notes and communities on different platforms such as Facebook including Messenger, Instagram, Twitter, WhatsApp, and different social applications. While implementing this I had to update the react-native-fbsdk library, change outdated ClientID’s in Facebook Developer Console and manage to implement a good sharing experience while not trespassing any of Facebook’s Platform Policies.',
        acquiredSkills: `In depth understanding of Redux flows in an app, communicating with the
        client, Sharing on various platforms, Image compression.`,
        technology: 'Firebase, React Native, Redux',
      },
    ],
  },
  // {
  //   name: "Andra E.",
  //   role: "Marketeer",
  //   profilePic: images.AndraElekes,
  //   profilePicHover: images.AndraElekesArt,
  //   responsibility: "Tech",
  //   experience: "4 years",
  //   email: "norbipostol@gmail.com",
  //   phone: "+40 755 123 456",
  //   facebook: "",
  //   instagram: "",
  //   linkedin: "",
  //   personalExp:
  //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  //   personalSkills: [
  //     {
  //       skill: "Communication",
  //       percentage: "100",
  //     },
  //     {
  //       skill: "Constructive feedback",
  //       percentage: "100",
  //     },
  //   ],
  //   projects: [],
  // },
  // {
  //   name: "Sylvi",
  //   role: "UI/UX Designer",
  //   profilePic: images.Sylvi,
  //   profilePicHover: images.SylviArt,
  //   responsibility: "",
  //   experience: "2 years",
  //   email: "",
  //   phone: "",
  //   facebook: "",
  //   instagram: "",
  //   linkedin: "",
  //   personalExp:
  //     "Hello! Nice to meet you! I’m Sylvi, a junior graphic & UI/UX designer with 2 years’ experience. I am a creative person, with an eye for colors and everything that is beautiful, orderly, and clear. Out of my passion and desire to create something beautiful and unique, I started my career by designing a logo. This took me into this moment and it was the spark which I needed to become a designer as I am now, with a wide knowledge acquired from my work and 5 projects.",
  //   personalSkills: [
  //     {
  //       skill: "Illustrator",
  //       percentage: "80",
  //     },
  //     {
  //       skill: "Figma",
  //       percentage: "75",
  //     },
  //     {
  //       skill: "Photoshop",
  //       percentage: "70",
  //     },
  //     {
  //       skill: "Project Management",
  //       percentage: "70",
  //     },
  //   ],
  //   projects: [
  //     {
  //       name: "DentaLife",
  //       projectType: "Web Dev",
  //       description: "",
  //       time: "",
  //       projectScreens: [],
  //       responsibilities: "",
  //       acquiredSkills: "",
  //       technology: "",
  //     },
  //     {
  //       name: "BookTrade",
  //       projectType: "Mobile Dev",
  //       description: "",
  //       time: "",
  //       projectScreens: [],
  //       responsibilities:
  //         "BookTrade is my first UI/UX project, where I developed my technical and leadership skills, as I was the project manager.",
  //       acquiredSkills: "",
  //       technology: "",
  //     },
  //     {
  //       name: "Oasis Residence",
  //       projectType: "Web Dev",
  //       description: "",
  //       time: "",
  //       projectScreens: [],
  //       responsibilities:
  //         "This is one of the most beautiful projects I’ve worked on. Together with the marketing team, I promoted this rental apartment, and through the graphics, I tried to reflect the minimalist and elegant style of the apartment.",
  //       acquiredSkills: "",
  //       technology: "",
  //     },
  //     {
  //       name: "Nomorecoffeeplease",
  //       projectType: "Web Dev",
  //       description: "",
  //       time: "",
  //       projectScreens: [],
  //       responsibilities: "",
  //       acquiredSkills: "",
  //       technology: "",
  //     },
  //     {
  //       name: "Romantic Studio Brasov",
  //       projectType: "Web Dev",
  //       description: "",
  //       time: "",
  //       projectScreens: [],
  //       responsibilities: "",
  //       acquiredSkills: "",
  //       technology: "",
  //     },
  //     {
  //       name: "MindHub",
  //       projectType: "Web Dev",
  //       description: "",
  //       time: "",
  //       projectScreens: [],
  //       responsibilities: "",
  //       acquiredSkills: "",
  //       technology: "",
  //     },
  //   ],
  // },
  {
    name: 'Marcel',
    role: 'Senior React-Native Dev',
    companyRelationship: 'collaborator',
    profilePic: images.Marcel,
    profilePicHover: images.MarcelArt,
    responsibility: '',
    experience: '4 years',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    personalExp:
      'For over 3 years I’ve been delighted to create mobile apps, as it was a passion of mine since entering college. Besides mobile development, I was attracted to software in general. That’s why I followed different paths: Mobile development, Backend development with Java and Security (all apps need security). An objective that I have is to create great meaningful apps and, in the meantime, to grow my programmer skills as well as the soft ones by working with a dedicated team that sees the success of the product. I also did estimations and product related decisions briefly and I want to be more comfortable doing those, and going into the next phase.',
    personalSkills: [
      {
        skill: 'Java-Script',
        percentage: '4 years',
      },
      {
        skill: 'Typescript:',
        percentage: '3.5 years',
      },
      {
        skill: 'React-Native',
        percentage: '3.5 years',
      },
      {
        skill: 'Firebase',
        percentage: '3.5 years',
      },
      {
        skill: 'Jira',
        percentage: '3.5 years',
      },
      {
        skill: 'Swift',
        percentage: '1 years',
      },
      {
        skill: 'Java Spring/Python',
        percentage: '1 years',
      },
    ],
    projects: [
      {
        name: 'Ness Technologies - Tranzact App Project',
        projectType: 'Web Dev',
        description: `Tranzact is a web page made for our client Zayo, for providing
        network/telephone services. The main features of the app are their handling orders/service
        management and support maintenance.`,
        time: 'June 2023- present',
        projectScreens: [],
        responsibilities: '',
        acquiredSkills: '',
        technology: 'React, Typescript, Redux Toolkit.',
      },
      {
        name: 'Ness Technologies - SmartAnalytics Project',
        projectType: 'Web Dev',
        description: 'Web platform.',
        time: 'February 2023 - June 2023',
        projectScreens: [],
        responsibilities: `For a short period of time, I worked on this app, where I had the chance to
        learn Vue for web development. I was part of a 4-man team that was handed the job of
        refactoring a web application from Vue2 to Vue3. I worked on this project for 2 months in this
        time I learned the basics of this language, it was challenging but since my knowledge of
        JavaScript is good, I managed to do my job. On this project I also had to add a few new features
        and solve some bugs. The features that I worked on:
        - Creating a new chart
        - Adding a list of templates, user can save them, make one as default and auto complete
        it on the form.
        - Adding a modal for saving templates.
        - Insert a new option into a form for the user to select the dates of the week needed for
        chart generation.`,
        acquiredSkills: '',
        technology: 'Vue2 & Vue3.',
      },
      {
        name: 'Ness Technologies - BandWidth Project',
        projectType: 'Web Dev',
        description: 'Web platform',
        time: 'November 2022 – February 2023',
        projectScreens: [],
        responsibilities: `For a short period of time, I worked on this app, where I had the chance to
          learn Vue for web development. I was part of a 4-man team that was handed the job of
          refactoring a web application from Vue2 to Vue3. I worked on this project for 2 months in this
          time I learned the basics of this language, it was challenging but since my knowledge of
          
          JavaScript is good, I managed to do my job. On this project I also had to add a few new features
          and solve some bugs. The features that I worked on:
          - Creating a new chart
          - Adding a list of templates, user can save them, make one as default and auto complete
          it on the form.
          - Adding a modal for saving templates.
          - Insert a new option into a form for the user to select the dates of the week needed for
          chart generation.`,
        acquiredSkills: '',
        technology: 'Vue2 & Vue3.',
      },
      {
        name: 'Ness Technologies - NetworkMonitoring Project',
        projectType: 'Mobile Dev',
        description: 'Mobile app.',
        time: 'July 2022 - November 2022',
        projectScreens: [],
        responsibilities: `In this project I worked alone, the client already had the web version of the
          app and I had to create a mobile version for it. For this application I decided to work with expo
          cli. I had an estimation session with the client and approached an agile way of working and
          divided the project into stories. This project took about one month at first it was just a POC so
          the client can decide after if he wants to continue with it. Features of the app:
          - Navigation using latest version of react-navigation.
          - Redux for state management tool and saga as middleware
          - API functions call to backend services.
          - Persisted store for handling tokens.
          - Login/Reset password functionality.
          - Selecting an organization based on a list for each user.
          - Showing a list of services for each organization.
          - Notifications in case the service status was warning/error.
          - Filtering the services by keywords`,
        acquiredSkills: '',
        technology: 'React-Native.',
      },
      {
        name: 'PeddyPower Betfair',
        projectType: 'Mobile Dev',
        description: 'Mobile Dev',
        time: 'June 2021 - June 2022',
        projectScreens: [],
        responsibilities: `For this project I worked on a team that implements games from different
          providers into a mobile application. The main framework of the project is in Swift and one of
          the products is a react-native application in which we had to import the swift framework as a
          native module.`,
        acquiredSkills: `- Swift/Objective C language
        - Working with native-modules in react-native.
        - Working with mono repos
        - Creating and running pipelines
        - Writing tests with jest
        - Creating builds
        - Improved my skills in working with a team.
        - Agile working`,
        technology: `Swift, React-Native (Most of my tasks on the swift framework were to
          solve bugs. And on react-native to implement functionalities since only 2 members of the team
          had react-native knowledge including me).`,
      },
      {
        name: 'BSR',
        projectType: 'Web Dev',
        description: `BSR is a B2B organization which helps identify potential risks or issues
          in any business, no matter its sector. BSR will interview all team members, gather data and
          based on these, will come up with a list of things to improve your business.`,
        time: 'January 2021 - June 2022',
        projectScreens: [],
        responsibilities:
          ': On this project I’ve learned to work with AmChart, where I had to finish the implementation of a chart that changes based on a timeline. The chart has multiple functionalities: the user can move, merge the data, and see the changes on the timeline. The user can also filter the data based on categories, labels, and regions. One task that I found to be challenging was making a dynamic table that changes based on the input data, the problem was the difference between inputs, and I was working with tables so I had to make it look good for each input. I’ve learned how to implement localisation with i18n and had to create files for 2 different languages and change the language based on the user choice and save that language for future logins. I also had to think of a way to disconnect a user after a period since AWS tokens doesn’t come with an expiration time. Another task that I had to do was to manage the upload and read data from a CSV file, to auto-complete a list with items. I’ve also had to implement a stage bar/ checkmarks functionality for projects, where the user could add a certain thing on the project, and the stage bar would rise and a checkmark will be filled. The backend of this app was made with Node.js and we used SQL queries to manipulate the data from the database, it was a good experience since I had to create or modify existing queries, I’ve learnt a lot about SQL and how to manipulate data. Overall, the project was pretty challenging, most of my task where functionalities and a few bugs, I’m happy that I worked with my team on this project, and I feel like I’ve made a lot of progress on this project not only on the technical side but also, I’ve improved my team working skills.',
        acquiredSkills: '',
        technology: 'React, AWS, SQL-DB',
      },
      {
        name: 'Oasis Residence',
        projectType: 'Web Dev',
        description: 'Aparthotel web platform.',
        time: 'August 2020 - January 2021',
        projectScreens: [],
        responsibilities:
          'On this app I’ve learned how to implement a payment system using the stripe library, it was pretty challenging as I had to use firebase functions as a backend. I also worked on the reservation system, after the payment is completed we save a reservation document for the user so other users can’t make a reservation for the same dates. Another task that I had to do is to implement Google Analytics to the project. I’ve chose to do that with google analytics 4 which is the latest method. For this task I also used firebase hosting to test it out, next step was to implement analytics for custom steps in the app. I created a backend using Django framework for the newsletter system, the app has 2 api’s for saving the emails and sending emails to the users. For hosting and deploying the app I used Heroku, it was a good opportunity to learn to use the platform.',
        acquiredSkills: `On this app I’ve learned how to implement a payment system using the stripe
        library, it was challenging as I had to use firebase functions as a backend. I also worked on the
        reservation system, after the payment is completed, we save a reservation document for the
        user so other users can’t make a reservation for the same dates.`,
        technology: 'React, Firebase, Stripe.',
      },
      {
        name: 'BookTrade',
        projectType: 'Mobile Dev',
        description: `A book trading app, whose goal isto facilitate the way people can acquire
        books. Instead of keeping the books in the library for ages, users have a real solution for trading
        them. This creates connections and communities.`,
        time: 'October 2019 - August 2020',
        projectScreens: [],
        responsibilities: `On this app I worked more on the IOS part, at first, I had to solve some UI
        issues in a few places and configure some libraries for IOS. After that the main feature I
        implemented was the apple login, and now I’m working on some UI changes especially for
        IOS. It was a good learning project where I learned to work with different libraries and how to
        make builds using Xcode. Also had some issues with the apple login but solving them helped
        me to understand the functionality better.`,
        acquiredSkills: '',
        technology: 'React Native.',
      },
      {
        name: 'Caravan App',
        projectType: 'Mobile Dev',
        description:
          'An app whose goal is to help real estate agents from San Diego to better manage the houses that are up for sell.',
        time: 'February 2019- October 2019',
        projectScreens: [],
        responsibilities:
          "On this app at first I had to solve multiple issues on all 3 components mobile app/web app/firebase functions. There were multiple bugs related with libraries that were too old, functionalities that didn't do what they were supposed to do. I was working alone on this app so from the moment we got the project I had to do all the tasks from bugs to features. I had to create new functions for statistics generation, changed the pdf-generation, work with lists with big data. I worked on the react native upgrade from 0.59 to 0.63. I also had to solve bugs on social media logins Facebook/Apple/Google/ UI bugs and some problems in the logic of other components. One of the main features was to implement a new list category with data from the admin panel and edit the current lists.",
        acquiredSkills: `On this project I’ve learn a lot about mobile development, I’ve got better on
        using Redux, working with firebase functions/ hosting and storage. I’ve learned how to use:
        - Google scheduler
        
        - Builds on IOS/Android
        - Version upgrades
        - Lists management.
        But most important I’ve also learned about the time management I had multiple tasks and had
        to split my time.`,
        technology: 'React-Native, Firebase.',
      },
    ],
  },
  {
    name: 'Catalin',
    role: 'Mid React-Native Dev',
    companyRelationship: 'collaborator',
    profilePic: images.Catalin,
    profilePicHover: images.CatalinArt,
    responsibility: '',
    experience: '3 years',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    personalExp:
      'Hello! I’m Catalin, nice to meet you! I’ve been a React-Native developer for 3 years now. My goal is to gain knowledge over Front End, to build and create from the scratch. I enjoyed playing on my computer since I was 6 years old, but when I got older the hardware part of the computer really got me, so I really liked building computers which is still a hobby of mine. Another hobby of mine is gaming, which has put me closer to the software part of the computer, I am a great team player for all of my projects, as I like to communicate and to practice my leadership skills.',
    personalSkills: [
      {
        skill: 'Javascript',
        percentage: '4 years',
      },
      {
        skill: 'React-Native',
        percentage: '3 years',
      },
      {
        skill: 'React',
        percentage: '3 years',
      },
      {
        skill: 'Git',
        percentage: '3 years',
      },
      {
        skill: 'Firebase',
        percentage: '3 years',
      },
      {
        skill: 'Jira',
        percentage: '3 years',
      },
      {
        skill: 'Typescript',
        percentage: '3 years',
      },
      {
        skill: 'Redux',
        percentage: '3 years',
      },
    ],
    projects: [
      {
        name: 'Haapi',
        projectType: 'Web Dev',
        description: `A JavaScript module that integrates HostAwayApi's for a simple implementation of its
        functionalities into any website that has apartments for rental.`,
        time: 'November 2023- Present',
        projectScreens: [],
        responsibilities:
          'Figuring out how the HostAwayApi works, implementing it into Firebase Cloud Functions',
        acquiredSkills: `how to use Firebase Cloud Functions, how to create a JS module, how the HostAwayApi
        works.`,
        technology: 'JavaScript, Firebase, HostAwayApi.',
      },
      {
        name: 'Odeen Software',
        projectType: 'Mobile Dev',
        description: `Offline first management app that aims to improve and automate the process of
        dispatching a maintenance worker to remote job sites.`,
        time: 'January 2023- November 2023',
        projectScreens: [],
        responsibilities: `Delivering efficient clean code, taking part in the review process, participating in
          meeting with the clients`,
        acquiredSkills: `Building an offline first application, Redux Offline, in depth understanding of Keycloak
        (creating a patch for the library).`,
        technology: 'Redux Offline, Keycloak, React Native, Typescript, React.',
      },
      {
        name: 'BookTrade',
        projectType: 'Mobile Dev',
        description: `A book trading app, whose goal is to facilitate the way people can acquire
        books. Instead of keeping the books in the library for ages, users have a real solution for trading
        them. This creates connections and communities.`,
        time: '2021 August – January 2023',
        projectScreens: [],
        responsibilities:
          'My main responsibility was to develop new features and to bug fix the already created ones, especially on Android. I’ve worked on the main functionality which was the matching system, and I’ve implemented the chat and the image picker. I’ve use firebase to manage all the data from the app, and I’ve integrated the Login and Register. Also, I’ve implemented notifications from chat. My biggest challenges were to make notifications work on IOS, and to get the matching system to work every swipe.',
        acquiredSkills: `How to use firebase for all purposes, like for verifying emails for new users.

        How to implement notifications for anything in app.`,
        technology:
          'React-Navigation, Redux & Saga, Facebook/Google Authentication, Firebase',
      },
      {
        name: 'Oasis Residence',
        projectType: 'Web Dev',
        description:
          'Aparthotel web platform, where users can book reservations.',
        time: '2021 May- 2021 August',
        projectScreens: [],
        responsibilities:
          'My main responsibility was to implement the design from Adobe XD. I’ve also implemented the calendar for reservation purpose, and I’ve worked with modals for many components. My biggest challenge was to make the calendar work for the reservation purpose.',
        acquiredSkills: '',
        technology: 'React, Firebase',
      },
      {
        name: 'Romantic Studio',
        projectType: 'Web Dev',
        description: `Romantic Studio Brasov consists of a website that, besides presenting a full of romance
        rental units for lovers, also allows you to inquire about a reservation using a contact form and a calendar similar
        to what you see on other booking platforms.`,
        time: '2021 January- 2021 May',
        projectScreens: [],
        responsibilities: `My main responsibility was to Implement UI from Figma, and to
          implement payment for reservations. Also, I’ve implement Stripe payment
          method.`,
        acquiredSkills: 'How to use Stripe payment method.',
        technology: 'React, Stripe.',
      },
      {
        name: 'Yael Consulting',
        projectType: 'Mobile Dev',
        description: 'IBEX',
        time: '2020 August- 2021 January',
        projectScreens: [],
        responsibilities:
          'My main responsibility was to Implement MUI components and to manage the frontend data. I’ve worked with MUI components and managed redux data. I’ve also manipulated the data from backend.',
        acquiredSkills: '',
        technology: 'React, Redux',
      },
      {
        name: 'Emoji Picker Challenge',
        projectType: 'Mobile Dev',
        description: '',
        time: '2020 June- 2020 August',
        projectScreens: [],
        responsibilities:
          'My main goal was to create an emoji picker similar to the one on Slack. I’ve developed the text input work. My biggest challenge was navigating through emoji’s categories.',
        acquiredSkills: '',
        technology: 'React-Native',
      },
      {
        name: 'Movie App Challenge',
        projectType: 'Mobile Dev',
        description: '',
        time: '2020 April- 2020 June',
        projectScreens: [],
        responsibilities: `My main goal was to gather data from the Star Wars API and to create a design for
          it. I’ve worked with an array of objects, and I’ve navigated from a category to the details of it. My
          biggest challenge was solving side-effects from multiple http fetches.`,
        acquiredSkills: 'Axios, React-Native navigation, Project architecture.',
        technology: 'React-Native',
      },
    ],
  },
  {
    name: 'Bogdan',
    role: 'Junior React-Native Developer',
    companyRelationship: 'internal',
    profilePic: images.BogdanPop,
    profilePicHover: images.BogdanPop,
    responsibility: '',
    experience: '1 year',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    personalExp: `Hello! Nice to meet you, I’m Bogdan, a Junior React & React-Native developer for 1 year now. I’m keen on anything that is tech-related, that’s why I hopped on this fast-moving train that is called Programming. I want to learn new technologies, improve what I already know and broaden my coding skills by working on a large variety of projects that include different frameworks and stacks.
      Even though I am a React and React-Native developer now, before starting this job I was experimenting a lot on my own with Python and its backend capabilities, such as its server-side rendering functionalities with Django and Flask, its data analysis with Matplotlib, NumPy and database management with MySQL.connector therefore I know some SQL syntax as well.
      `,
    personalSkills: [
      {
        skill: 'React-Native',
        percentage: '',
      },
      {
        skill: 'React',
        percentage: '',
      },
      {
        skill: 'Javascript',
        percentage: '',
      },
      {
        skill: 'Git',
        percentage: '',
      },
      {
        skill: 'Firebase',
        percentage: '',
      },
      {
        skill: 'Typescript',
        percentage: '',
      },
      {
        skill: 'Redux',
        percentage: '',
      },
      {
        skill: 'Architect',
        percentage: '',
      },
      {
        skill: 'OOP',
        percentage: '',
      },
      {
        skill: 'SQL',
        percentage: '',
      },
      {
        skill: 'Django, Flask',
        percentage: '',
      },
      {
        skill: 'MySQL',
        percentage: '',
      },
      {
        skill: 'Tkinter',
        percentage: '',
      },
      {
        skill: 'smtplib',
        percentage: '',
      },
      {
        skill: 'Agile',
        percentage: '',
      },
    ],
    projects: [
      {
        name: 'Prestige Cakes',
        projectType: 'Web Dev',
        description: `An e-commerce website for a local pastry shop`,
        time: 'November 2023- December 2023',
        projectScreens: [],
        responsibilities: 'Front-end, Firebase configuration and usage',
        acquiredSkills: `how to setup Firebase from scratch and implement it into a React project`,
        technology: 'React, Firebase, SCSS.',
      },
      {
        name: 'BookTrade',
        projectType: 'Mobile Dev',
        description: `A mobile app where you can trade your books and talk with your friends about the books you've read`,
        time: 'May 2023 - October 2023',
        projectScreens: [],
        responsibilities:
          'Fixing the phone number authentication, Fixing barcode scanning functionality, Fixing the group chats and what happens to a user once the account is deleted, Some Front-end tweaking, Fixing bugs and improving the app experience.',
        acquiredSkills: `proficiency in working on big projects and how to maintain them, writing clean, reusable code and how to check for edge cases before sending the code to testing`,
        technology: 'React-Navigation, Redux & Saga, Firebase',
      },
      {
        name: 'Oasis Residence',
        projectType: 'Web Dev',
        description:
          'Aparthotel web platform, where users can book reservations.',
        time: 'April 2023- May 2023',
        projectScreens: [],
        responsibilities: 'Front-end',
        acquiredSkills:
          'how to use React to create a snappy-feeling website and how to use SCSS to create a modern-looking website',
        technology: 'React, SCSS',
      },
      {
        name: 'Haapi',
        projectType: 'Web Dev',
        description: `A JavaScript module that integrates HostAwayApi's for a simple implementation of its functionalities into any website that has apartments for rental`,
        time: 'February 2023- April 2023',
        projectScreens: [],
        responsibilities: 'Front-end',
        acquiredSkills: `how to use React to create a snappy-feeling website and how to use SCSS to create a modern-looking website`,
        technology: 'React, JavaScript, Firebase, HostAwayApi.',
      },
      {
        name: 'Emoji Picker Challenge',
        projectType: 'Mobile Dev',
        description: '',
        time: 'January 2023- February 2023',
        projectScreens: [],
        responsibilities:
          'My main goal was to create an emoji picker like the one on Slack.',
        acquiredSkills: 'JavaScript',
        technology: 'React-Native',
      },
    ],
  },
  {
    name: 'Tudor',
    role: 'Junior React Dev',
    companyRelationship: 'internal',
    profilePic: images.TudorEugeniu,
    profilePicHover: images.TudorEugeniuArt,
    responsibility: '',
    experience: '1 year',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    personalExp: `Hello! I am a React Web Developer with 1 year of experience. I am a curious person and
      I enjoy learning new and exciting things every day. I am passionate about software, hardware
      and security and I really enjoy learning how technology and systems work. I chose web
      development because I think it is a great way to start an IT career. I am currently working only as
      a front-end developer, but I wish to dive deeper into the back-end and security side of things as
      well.`,
    personalSkills: [
      {
        skill: 'React',
        percentage: '1 year',
      },
      {
        skill: 'Javascript',
        percentage: '1 year',
      },
      {
        skill: 'Typescript',
        percentage: '1 year',
      },
      {
        skill: 'Git',
        percentage: '1 year',
      },
    ],
    projects: [
      {
        name: 'Prestige Cakes',
        projectType: 'Web Dev',
        description: `An e-commerce website for a local pastry shop`,
        time: 'January 2024',
        projectScreens: [],
        responsibilities:
          'UI & UX component development and routing of different screens, making components responsive.',
        acquiredSkills: `Responsive design, Component development, Routing, Styling.`,
        technology: 'React, Firebase, SCSS.',
      },
      {
        name: 'NoMoreCoffeePlease Website',
        projectType: 'Web Dev',
        description: `This is the site of our company, its goal is to provide information about
        what we are all about. Here you can find information about the team, the services we provide, all
        the projects we are working on and our goals, we also have a blog section where we talk about
        recent events and other tech related topics, you will also find information about how we can get
        in touch.`,
        time: 'Sept 2023',
        projectScreens: [],
        responsibilities:
          'Adding new UI elements and changing old ones, making components responsive.',
        acquiredSkills: `Responsive design, Component development, Styling.`,
        technology: 'React, SCSS.',
      },
      {
        name: 'Haapi',
        projectType: 'Web Dev',
        description: `A JavaScript module that integrates HostAwayApi's for a simple
        implementation of its functionalities into any website that has apartments for rental`,
        time: 'August 2023',
        projectScreens: [],
        responsibilities:
          'Develop the UI components, making components responsive.',
        acquiredSkills: `Responsive design, Component development, Styling.`,
        technology: 'React, SCSS.',
      },
      {
        name: 'AI Powered Booking Engine',
        projectType: 'Web Dev',
        description: `The final goal of this project is to create an adaptive AI powered booking
        engine that can be used in different environments. The bot is able to collect user booking
        information and also respond to any question the user might have about the booking, all this
        information is then sent to a backend.`,
        time: 'July 2023',
        projectScreens: [],
        responsibilities:
          'Creating a chat room where users can talk to a bot that collects their booking data and can answer their questions.',
        acquiredSkills: `Working with the OpenAI API`,
        technology: 'React, SCSS.',
      },
      {
        name: 'BSR',
        projectType: 'Web Dev',
        description: `Materiality Web is an internal app that we developed for our client, BSR.
        The app is based on a multitude of data points that are integrated into a single chart that is time
        based and has a history of changes.`,
        time: 'January 2023 - present',
        projectScreens: [],
        responsibilities: `Fixing bugs and errors, Code refactoring, UI additions and documentation of
        changes.`,
        acquiredSkills: `Manual Testing, Debugging, Documentation of Issues and Solutions,
          Teamwork, Communication and Problem Solving.`,
        technology: `React.Js, CSS`,
      },
      {
        name: 'Figma Website Challenge',
        projectType: 'Web Dev',
        description: `The goal was to recreate a website design from figma and make it
        responsive.`,
        time: 'December 2022',
        projectScreens: [],
        responsibilities:
          'Create the website structure, develop the UI components, making the site responsive.',
        acquiredSkills: `Responsive design, Component development, Styling.`,
        technology: 'React.Js, SCSS, React Router',
      },
      {
        name: 'Emoji Picker Challenge',
        projectType: 'Web Dev',
        description: `Create an emoji picker for an eventual chat app. Responsibilities: My main
        goal was to create an emoji picker like the one on Slack. I’ve developed text input work. My
        biggest challenge was navigating through emoji’s categories.`,
        time: 'November 2022',
        projectScreens: [],
        responsibilities: '',
        acquiredSkills: `Creating a useful and reusable component, Flat List optimisation.`,
        technology: 'React.Js, SCSS',
      },
    ],
  },
  // {
  //   name: "Bogdan",
  //   role: "Junior React-Native Dev",
  //   profilePic: images.BogdanTinta,
  //   profilePicHover: images.BogdanTintaArt,
  //   responsibility: "",
  //   experience: "1 year",
  //   email: "",
  //   phone: "",
  //   facebook: "",
  //   instagram: "",
  //   linkedin: "",
  //   personalExp:
  //     "Hello! My name is Bogdan. I am React-Native Developer for 1 year now. I am striving every day to learn new things and hone my already acquired skills, not only regarding programming, but also on a personal level. I chose mobile development because I think creating a useful mobile app is the best way to have an impact on a wider range of people, simply because today almost everyone has access to the digital world through their mobile device. I am currently working only as a front-end developer, but I wish to delve deeper into the back-end” world” and also to learn web (React) development for the purpose of being more versatile.",
  //   personalSkills: [
  //     {
  //       skill: "React-Native",
  //       percentage: "70",
  //     },
  //     {
  //       skill: "Javascript",
  //       percentage: "75",
  //     },
  //     {
  //       skill: "Git",
  //       percentage: "70",
  //     },
  //     {
  //       skill: "Redux",
  //       percentage: "70",
  //     },
  //     {
  //       skill: "Firebase",
  //       percentage: "70",
  //     },
  //     {
  //       skill: "HTML",
  //       percentage: "60",
  //     },
  //     {
  //       skill: "CSS",
  //       percentage: "60",
  //     },
  //   ],
  //   projects: [
  //     {
  //       name: "DentaLike",
  //       projectType: "Mobile Dev",
  //       description: `Dental Clinic Website. The project involved creating a presentation
  //       website with NextJS for a dental clinic.`,
  //       time: "February 2023 – present",
  //       projectScreens: [],
  //       responsibilities: `I was tasked mainly with design implementation from A to Z and with the
  //         accomodation of a newly employed intern.`,
  //       acquiredSkills:
  //         "Teamwork, Communication, NextJS project structuring, better understanding of React.",
  //       technology: "NextJS, HTML, CSS, React.",
  //     },
  //     {
  //       name: "BookTrade",
  //       projectType: "Mobile Dev",
  //       description: `A book trading app, whose goal is to facilitate the way people can acquire
  //       books. Instead of keeping the books in the library for ages, users have a real solution for trading
  //       them. This creates connections and communities.`,
  //       time: "January 2022 - February 2023",
  //       projectScreens: images.projectScreens.bookTrade,
  //       responsibilities:
  //         "As it was my first official project and the first time I was working in a team, I had to integrate into the team and get familiar with Figma, Jira and project setups. In the first two weeks I was tasked with bug fixing, which was an opportunity for me to get acquainted with the project’s overall structure. Later I had to work on more complex tasks such as feature implementation and through these tasks I gained experience in working with Redux and Firebase. The main features of the app were already in place, thus, I was given tasks regarding the social part of the app as well as the overall user experience. Some of the most notable features that I implemented (and the most challenging) are a fully functional Group chat (group creation, editing, group features such as admin ranks), and animations with React-Native Animated / Reanimated.",
  //       acquiredSkills: `Working with Redux, Git, Firebase, React Animated/Reanimated, Flexbox
  //       styling, working with Figma designs, task management (Jira), teamwork, preparing and
  //       presenting demos, code reviewing, clean coding, Android Studio/Xcode`,
  //       technology: "React Native, Firebase.",
  //     },
  //     {
  //       name: "Star Wars Wiki Challenge",
  //       projectType: "Web Dev",
  //       description: `The challenge was to build a React-Native wiki-type app, fetching data
  //       from a sub-optimal API. As a secondary task, I had to create a good-looking design from
  //       scratch.`,
  //       time: "January 2022",
  //       projectScreens: [],
  //       responsibilities:
  //         "The challenge was about building a React-Native wiki-type app, fetching data from a sub-optimal API. As a secondary task, I had to create a good-looking design from scratch.",
  //       acquiredSkills: `Project creation, project structuring, API requests, creating a themed and
  //       meaningful design.`,
  //       technology: "React-Native",
  //     },
  //     {
  //       name: "Emoji Picker Challenge",
  //       projectType: "Mobile Dev",
  //       description: "Create an emoji picker for an eventual chat app.",
  //       time: "January 2022",
  //       projectScreens: [],
  //       responsibilities: `My main goal was to create an emoji picker like the one on Slack. I’ve
  //       developed text input work. My biggest challenge was navigating through emoji’s categories.`,
  //       acquiredSkills:
  //         "Creating a useful and reusable component, Flat List optimization.",
  //       technology: "React-Native",
  //     },
  //   ],
  // },
];

export const blogCategoryArray = [
  { title: 'All', color: colors.turquoise },
  { title: 'Development', color: colors.orange },
  { title: 'Design', color: colors.pink },
  { title: 'Marketing', color: colors.secondary },
  { title: 'News', color: colors.primaryTransparent },
];

export const blogArray = [
  {
    title: 'Web Development: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.webDevBlog,
    category: 'Development',
    all: 'All',
    color: colors.orange,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Development: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.webDevBlog,
    category: 'Development',
    all: 'All',
    color: colors.orange,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Development: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.webDevBlog,
    category: 'Development',
    all: 'All',
    color: colors.orange,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Development: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.webDevBlog,
    category: 'Development',
    all: 'All',
    color: colors.orange,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Development: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.webDevBlog,
    category: 'Development',
    all: 'All',
    color: colors.orange,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Development: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.webDevBlog,
    category: 'Development',
    all: 'All',
    color: colors.orange,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Development: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.webDevBlog,
    category: 'Development',
    all: 'All',
    color: colors.orange,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Development: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.webDevBlog,
    category: 'Development',
    all: 'All',
    color: colors.orange,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Development: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.designBlog,
    category: 'Design',
    all: 'All',
    color: colors.pink,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Design: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.designBlog,
    category: 'Design',
    all: 'All',
    color: colors.pink,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Design: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.designBlog,
    category: 'Design',
    all: 'All',
    color: colors.pink,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Design: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.designBlog,
    category: 'Design',
    all: 'All',
    color: colors.pink,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Design: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.designBlog,
    category: 'Design',
    all: 'All',
    color: colors.pink,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Development: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.marketingBlog,
    category: 'Marketing',
    all: 'All',
    color: colors.secondary,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Marketing: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.marketingBlog,
    category: 'Marketing',
    all: 'All',
    color: colors.secondary,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Marketing: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.marketingBlog,
    category: 'Marketing',
    all: 'All',
    color: colors.secondary,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Marketing: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.marketingBlog,
    category: 'Marketing',
    all: 'All',
    color: colors.secondary,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
  {
    title: 'Web Marketing: Tips and Tricks',
    date: '20 Dec, 2020',
    image: images.marketingBlog,
    category: 'Marketing',
    all: 'All',
    color: colors.secondary,
    background: images.blogPostBackground,
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
  },
];

export const projectScreens = {
  bookTrade: images.projectScreens.bookTrade,
};

export const aboutUsImageArray = [
  {
    image: images.aboutUs.teamwork,
    text: strings.aboutUs.teamwork,
    color: colors.lightningYellow,
  },
  {
    image: images.aboutUs.empoweringCommunities,
    text: strings.aboutUs.empoweringCommunities,
    color: colors.mauvelous,
  },
  {
    image: images.aboutUs.equity,
    text: strings.aboutUs.equity,
    color: colors.cherokee,
  },
  {
    image: images.aboutUs.friendship,
    text: strings.aboutUs.friendship,
    color: colors.cherokee,
  },
  {
    image: images.aboutUs.growth,
    text: strings.aboutUs.growth,
    color: colors.lightningYellow,
  },
  {
    image: images.aboutUs.transparency,
    text: strings.aboutUs.transparency,
    color: colors.mauvelous,
  },
];

export const staffArray = [
  {
    name: 'Andrei Stoica',
    role: 'CEO',
    image: images.Stoica,
  },
  {
    name: 'Andreea Stoica',
    role: 'HR',
    image: images.Andreea,
  },
  {
    name: 'Bianca Baciu',
    role: 'BD',
    image: images.BiancaBaciu,
  },
];

export const optionsArray = [
  {
    value: 'Business',
    id: 'business',
  },
  {
    value: 'Internship',
    id: 'internship',
  },
  {
    value: 'New Project',
    id: 'newProject',
  },
  {
    value: 'Community',
    id: 'community',
  },
];

export const ourworkDetailsArray = [
  {
    icon: images.ourwork.development,
    title: strings.ourwork.projects,
    value: 13,
    color: '#EDA751',
  },
  {
    icon: images.ourwork.suitcase,
    title: strings.ourwork.partners,
    value: 7,
    color: '#6AA5AC',
  },
  {
    icon: images.ourwork.handshake,
    title: strings.ourwork.collaborators,
    value: 23,
    color: '#FF91AB',
  },
];
